import React, { useState, useEffect } from 'react';
import { fetchData } from '../api/restapi';
import '../assets/AllTabsCommon.css';
import '../assets/FleetAnalytics.css';

const VISIBILITY_TABS = [
    { key: 'internal', label: 'Internal' },
    { key: 'external', label: 'External' },
    { key: 'ai', label: 'AI' },
];

function PlatformHealth() {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [visibilityTab, setVisibilityTab] = useState('internal');

    useEffect(() => {
        const loadReports = async () => {
            try {
                const data = await fetchData('/api/v1/reports');
                if (data && data.reports && Array.isArray(data.reports)) {
                    setReports(data.reports);
                } else {
                    setReports([]);
                }
            } catch (error) {
                console.error('Error fetching reports:', error);
                setReports([]);
            } finally {
                setLoading(false);
            }
        };
        loadReports();
    }, []);

    const filteredReports = reports.filter((r) => r.visibility === visibilityTab);

    return (
        <div className="analytics-shell">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 700, color: '#1e293b' }}>Reports</h2>
                <div className="analytics-rt-sub-tabs">
                    {VISIBILITY_TABS.map((t) => (
                        <button
                            key={t.key}
                            className={`analytics-rt-sub-tab${visibilityTab === t.key ? ' active' : ''}`}
                            onClick={() => setVisibilityTab(t.key)}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>
            </div>

            <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                {loading ? (
                    <div style={{ padding: '40px', textAlign: 'center', color: '#94a3b8', fontSize: '14px' }}>
                        Loading reports...
                    </div>
                ) : (
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ background: '#f8fafc' }}>
                                <th style={{ padding: '12px 20px', textAlign: 'left', fontSize: '12px', fontWeight: 600, color: '#64748b', borderBottom: '1px solid #e2e8f0', letterSpacing: '0.04em', textTransform: 'uppercase' }}>
                                    Report Name
                                </th>
                                <th style={{ padding: '12px 20px', textAlign: 'left', fontSize: '12px', fontWeight: 600, color: '#64748b', borderBottom: '1px solid #e2e8f0', letterSpacing: '0.04em', textTransform: 'uppercase' }}>
                                    Description
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredReports.length > 0 ? (
                                filteredReports.map((report, index) => (
                                    <tr key={index} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                        <td style={{ padding: '13px 20px', fontSize: '13.5px', color: '#1e293b' }}>
                                            <a
                                                href={report.reportLink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: '#3253DC', textDecoration: 'none', fontWeight: 500 }}
                                                onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                                onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}
                                            >
                                                {report.reportName}
                                            </a>
                                        </td>
                                        <td style={{ padding: '13px 20px', fontSize: '13.5px', color: '#64748b' }}>
                                            {report.description || ''}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={2} style={{ padding: '40px', textAlign: 'center', color: '#94a3b8', fontSize: '14px' }}>
                                        No {visibilityTab} reports available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}

export default PlatformHealth;
